exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3iD4tGRoFNUyNY0L3SwGqa{overflow:auto}html[dir] ._3iD4tGRoFNUyNY0L3SwGqa{padding:0 10px}._3rGPyS-T4z661D_PbTU36A{white-space:pre-wrap}", ""]);
// Exports
exports.locals = {
	"main": "_3iD4tGRoFNUyNY0L3SwGqa",
	"textContent": "_3rGPyS-T4z661D_PbTU36A"
};